import { useQuery } from '@tanstack/react-query';
import { getSubdomain } from '@zealy/utils';
import { questKeys } from '../quests.keys';
import { hasVoteQuest } from '../quests.service';
export function useHasVoteQuest(enabled = true) {
    const subdomain = getSubdomain();
    return useQuery({
        queryKey: questKeys.hasVoteQuest(subdomain),
        queryFn: () => hasVoteQuest(subdomain),
        enabled: subdomain !== 'root' && enabled,
        staleTime: 30000,
    });
}
